export default __webpack_public_path__ + "14ad749ffe45a7234833a2cb247984c5.svg";